import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AdminAuthService } from '../services/admin-auth.service';
import { PortalAuthService } from '../services/portal-auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const adminAuth = inject(AdminAuthService);
  const portalAuth = inject(PortalAuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        if (req.url.includes('/admin/')) {
          adminAuth.logout();
        } else if (req.url.includes('/portal/')) {
          portalAuth.logout();
        }
      }
      return throwError(() => error);
    })
  );
};
